module.exports = __webpack_public_path__ + "static/media/sikom-black.ed97b92c.png";